var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobile)?_c('v-btn',{staticClass:"mobile-create-button",attrs:{"fab":"","large":"","color":"primary"}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("mdi-plus")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }